import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { getOtherOptionsFromWindow } from "../../utils/getOtherOptionsFromWindow.js";
import { __, _i } from "../../utils/i18n.js";
const NoticeAnonymousScriptNotWritable = observer(()=>{
    const { showNoticeAnonymousScriptNotWritable } = getOtherOptionsFromWindow();
    return !!showNoticeAnonymousScriptNotWritable && /*#__PURE__*/ _jsx("div", {
        className: "notice notice-warning inline below-h2 notice-alt",
        style: {
            margin: "10px 0 0 0"
        },
        children: /*#__PURE__*/ _jsx("p", {
            children: _i(__("Your {{code}}wp-content{{/code}} folder is not writable. Please check your permissions!"), {
                code: /*#__PURE__*/ _jsx("code", {})
            })
        })
    });
});
export { NoticeAnonymousScriptNotWritable };
